import useSWR from "swr";
import { api, fetcher } from "services/api.service";
import { useCallback } from "react";

export const useFeatureFlag = function (name: string) {
  const { data, isLoading, mutate } = useSWR<{ enabled: boolean }>(`/feature_flags/${name}`, fetcher, {
    revalidateIfStale: false,
  });

  const toggleFeatureFlag = useCallback(() => {
    const value = !data?.enabled;
    api.put(`/feature_flags/${name}`, { enabled: value }).then(() => {
      mutate({ enabled: value });
    });
  }, [name, data?.enabled, mutate]);

  return { enabled: data?.enabled, isLoading, toggleFeatureFlag };
};
